import { FC } from 'react'

const WarningIcon: FC<React.SVGProps<SVGSVGElement>> = ({ ...rest }) => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M17.1541 4.00059L29.8555 26.0006C29.9725 26.2033 30.0341 26.4332 30.0341 26.6673C30.0341 26.9013 29.9725 27.1312 29.8555 27.3339C29.7385 27.5366 29.5702 27.7049 29.3675 27.8219C29.1648 27.939 28.9349 28.0006 28.7008 28.0006H3.29814C3.0641 28.0006 2.83418 27.939 2.63149 27.8219C2.4288 27.7049 2.26049 27.5366 2.14347 27.3339C2.02645 27.1312 1.96484 26.9013 1.96484 26.6673C1.96485 26.4332 2.02645 26.2033 2.14348 26.0006L14.8448 4.00059C14.9618 3.79792 15.1302 3.62961 15.3328 3.5126C15.5355 3.39559 15.7654 3.33398 15.9995 3.33398C16.2335 3.33398 16.4634 3.39559 16.6661 3.5126C16.8688 3.62961 17.0371 3.79792 17.1541 4.00059ZM5.60748 25.3339H26.3915L15.9995 7.33393L5.60748 25.3339ZM14.6661 21.3339H17.3328V24.0006H14.6661V21.3339ZM14.6661 12.0006H17.3328V18.6673H14.6661V12.0006Z'
        fill='white'
      />
    </svg>
  )
}

export default WarningIcon
